export const POST_PROPERTY_REQUEST = "POST_PROPERTY_REQUEST";
export const POST_PROPERTY_SUCCESS = "POST_PROPERTY_SUCCESS";
export const POST_PROPERTY_FAILURE = "POST_PROPERTY_FAILURE";
